module.exports = __webpack_public_path__ + "img/homeScreenRe2.eac6872a.svg";